export default {
  "container": "_container_vopk2c",
  "badge": "_badge_vopk2c",
  "title": "_title_vopk2c",
  "button": "_button_vopk2c"
};
